/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_TitleInputs */

const en_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync Changes`)
};

const fr_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser les modifications`)
};

const de_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen synchronisieren`)
};

const it_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizza modifiche`)
};

const ru_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения синхронизации`)
};

const es_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar cambios`)
};

const zh_cn2_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步更改`)
};

const ja_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を同期`)
};

const hi_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को सिंक्रनाइज़ करें`)
};

const pt_pt2_sync_changes_title = /** @type {(inputs: Sync_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar alterações`)
};

/**
* | output |
* | --- |
* | "Sync Changes" |
*
* @param {Sync_Changes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_title = /** @type {((inputs?: Sync_Changes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_title(inputs)
	if (locale === "de") return de_sync_changes_title(inputs)
	if (locale === "it") return it_sync_changes_title(inputs)
	if (locale === "ru") return ru_sync_changes_title(inputs)
	if (locale === "es") return es_sync_changes_title(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_title(inputs)
	if (locale === "ja") return ja_sync_changes_title(inputs)
	if (locale === "hi") return hi_sync_changes_title(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_title(inputs)
	return en_sync_changes_title(inputs)
});